module.exports = __webpack_public_path__ + "static/media/4-5.92cc5496.mp3";